import { render, staticRenderFns } from "./CourseRegistrationsTable.vue?vue&type=template&id=4037a904&"
import script from "./CourseRegistrationsTable.vue?vue&type=script&lang=ts&"
export * from "./CourseRegistrationsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports